import * as React from 'react';
import './style.scss'

export interface IHeaderState {
    scrollY: number
}

export default class ReturnTop extends React.Component<{}, IHeaderState> {
    constructor(props: {}){
        super(props);
        this.onScrollHandle = this.onScrollHandle.bind(this);
    }

    public returnTop() {
        scrollTo({ top: 0, behavior: "smooth" })
    }

    public componentDidMount() {
        window.addEventListener('scroll', this.onScrollHandle);
    }

    public onScrollHandle() {
        this.setState({ scrollY: window.scrollY });
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollHandle);
    }

    public render() {
        return (
            <div className="return-top">
                {scrollY > 1200 ? <img onClick={this.returnTop} src={require("@static/top.png")} alt="域起官网" /> : ''}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ReturnTop/index.tsx